module.exports = __webpack_public_path__ + "static/media/mahon.a161fe8c.png";